import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    fetchedTag,
    createdTag,
    updatedTag,
    deletedTag,
    fetchedVocabularies,
    fetchedVocabularyLevels,
    fetchedTagParents,
    fetchedTagTranslations,
    fetchedTagTranslation,
    deletedTagTranslation
} from './actions';

export function fetchTag(tagId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tagId}`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedTag(response.data)));
    }
}

export function createTag(tag) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags`,
            method: 'POST',
            data: {
                vocabularyId: tag.vocabulary_id,
                term: tag.display_name,
                level: tag.level,
                parentId: tag.parent_id,
                tagosId: tag.tagos_id
            }
        };
        return request(options, dispatch)
            .then(response => dispatch(createdTag(response)))
            .then(() => toastr.success('Success!', 'The tag has been created.'))
            .then(() => dispatch(push(`/tags`)));
    }
}

export function updateTag(tag) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tag.id}`,
            method: 'PUT',
            data: {
                id: tag.id,
                vocabularyId: tag.vocabulary_id,
                term: tag.display_name,
                level: tag.level,
                parentId: tag.parent_id,
                tagosId: tag.tagos_id
            }
        };
        return request(options, dispatch)
            .then(response => dispatch(updatedTag(tag)))
            .then(() => toastr.success('Success!', 'Tag "' + tag.display_name + '" has been updated.'));
    }
}

export function deleteTag(tag) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tag}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedTag(tag)))
            .then(() => toastr.success('Success!', 'Tag ' + tag + ' has been deleted.'))
    }
}

export function fetchVocabularies() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/vocabularies`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedVocabularies(response.data)));
    }
}

export function fetchVocabularyLevels(vocabularyId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/vocabulary-levels?vocabularyId=${vocabularyId}`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedVocabularyLevels(response.data)));
    }
}

export function fetchTagParents(vocabularyId, level) {
    level = level - 1;

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tag-parents?vocabularyId=${vocabularyId}&level=${level}`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedTagParents(response.data)));
    }
}

export function fetchTagTranslations(tagId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tagId}/translations`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedTagTranslations(response.data)));
    }
}

export function fetchTagTranslation(tagId, translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tagId}/translations/${translationId}`,
            method: 'GET',
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedTagTranslation(response.data)));
    }
}

export function createTagTranslation(newTranslatedName, tagId, siteId) {

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tagId}/translations`,
            method: 'POST',
            data: {
                term: newTranslatedName,
                siteId: siteId,
            }
        };
        return request(options, dispatch)
            .then(() => dispatch(fetchTagTranslations(tagId)))
            .then(() => toastr.success('Success!', 'The tag translation has been created.'))
    }
}

export function updateTagTranslation(tagTranslationBySite, tagId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tagId}/translations/${tagTranslationBySite.id}`,
            method: 'PUT',
            data: {
                term: tagTranslationBySite.display_name,
                siteId: tagTranslationBySite.site_id
            }
        };
        return request(options, dispatch)
            .then(() => dispatch(fetchTagTranslations(tagId)))
            .then(() => toastr.success('Success!', 'The tag translation has been updated.'))
    }
}

export function deleteTagTranslation(tagId, translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/tags/${tagId}/translations/${translationId}`,
            method: 'DELETE'
        };
        return request(options, dispatch)
            .then(response => dispatch(deletedTagTranslation(translationId)))
            .then(() => toastr.success('Success!', 'Tag translation ' + translationId + ' has been deleted.'))
    }
}


// WEBPACK FOOTER //
// ./src/containers/tags/thunks.js